import { Helmet } from 'react-helmet';
import type { Product } from '../../bff-api/products/model';

export const QuestionSchema = ({ product }: { product?: Product }) => {
    if (product) {
        const { c_questionsSchema } = product;
        if (c_questionsSchema) {
            return (
                <Helmet>
                    <script type="application/ld+json">
                        {JSON.stringify(c_questionsSchema, null, 2)}
                    </script>
                </Helmet>
            );
        }
    }
    return null;
};
